import { zip } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
// types
import { IEpic } from 'types/epic';
import { IAction } from 'types/action';
// actions
import { setLoadingManagerState } from './loading-manager.actions';
import { LOADING_STATE } from 'modules/loading-manager/loading-manager.constants';
import { WEBSITE_MODE } from '@sitegen/common/constants';
import IConfig from '@sitegen/common/constants/config';

// TODO add proper epic for sessionLoading
export const loadingManagerEpicFactory = (actions: { modeAgnostic: string[], standalone?: string[] }): IEpic => {
    return (action$: ActionsObservable<IAction>, state$: StateObservable<IState>) => {
        const combinedActions = state$.value.config.mode === WEBSITE_MODE.STANDALONE && actions.standalone
            ? [
                ...actions.modeAgnostic,
                ...actions.standalone
            ]
            : actions.modeAgnostic;

        return zip(...combinedActions.map(actionType => action$.pipe(ofType(actionType)))).pipe(
            first(),
            map(() => setLoadingManagerState(LOADING_STATE.LOADED))
        );
    };
};

interface IState {
    readonly config: IConfig;
}
